var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Queue } from './queue';
import { $$, $e, $icon, on, $tap, $hiddens, xsrfToken, $n } from './utils';
var kid = 0;
function $size(num) {
    var opts = { maximumFractionDigits: 2 };
    num = +num;
    return num >= 1048576
        ? "".concat($n(num / 1048576, opts), " \u30E1\u30AC\u30D0\u30A4\u30C8")
        : num >= 1024
            ? "".concat($n(num / 1024, opts), " \u30AD\u30ED\u30D0\u30A4\u30C8")
            : "".concat($n(num), " \u30D0\u30A4\u30C8");
}
function fileEntry(name, entry, type, hasRemove) {
    if (hasRemove === void 0) { hasRemove = true; }
    var file = entry.file || { name: entry.filename, type: entry.mime_type, size: entry.size };
    var trash = $icon('fas fa-square-xmark', { className: 'upload-entry-trash', title: '削除', hidden: !hasRemove });
    var url = undefined;
    var content = /^image\//.test(file.type) || /\.(jpe?g|png|gif)$/i.test(file.name)
        ? $e('img', {
            src: entry.file ? (url = URL.createObjectURL(entry.file)) : "/api/".concat(type, "/").concat(entry.object_key),
            className: 'upload-entry-image',
        })
        : file.type === 'application/pdf' || /\.pdf$/i.test(file.name)
            ? $icon('far fa-file-pdf', { className: 'upload-entry-icon' })
            : $icon('far fa-file', { className: 'upload-entry-icon' });
    var title = "".concat(file.name, " (").concat($size(file.size), ")");
    var key = kid++;
    var li = $e.apply(void 0, __spreadArray(['li',
        { className: 'upload-entry', title: title },
        trash,
        content,
        $e('span', { className: 'upload-entry-title' }, title)], $hiddens("".concat(name, "[").concat(key, "]"), {
        object_key: entry.object_key,
        filename: file.name,
        mime_type: file.type,
        size: file.size,
    }), false));
    if (url)
        li.dataset.url = url;
    return li;
}
function handleUpload(elem) {
    return __awaiter(this, void 0, void 0, function () {
        var files, cntr, maxSize, exceededFile, name, uploaded, errorBag, btn, currFiles, maxFiles, uploads, _i, files_1, file, progress, alertUpload, q, _loop_1, _a, uploads_1, _b, file, progress, err_1;
        var _this = this;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    files = Array.from(elem.files || []);
                    cntr = elem.closest('.upload-files');
                    maxSize = +(cntr.dataset.maxMb || 10) * 1048576;
                    exceededFile = files.find(function (file) { return file.size > maxSize; });
                    if (exceededFile) {
                        alert("\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3067\u304D\u308B\u30D5\u30A1\u30A4\u30EB\u306F1\u30D5\u30A1\u30A4\u30EB\u5F53\u305F\u308A ".concat($size(maxSize), " \u4EE5\u4E0B\u3067\u3059\u3002\n") +
                            "\uFF08".concat(exceededFile.name, " \u306F ").concat($size(exceededFile.size), " \u3067\u3059\uFF09"));
                        elem.value = '';
                        return [2 /*return*/];
                    }
                    name = cntr.dataset.name;
                    uploaded = cntr.querySelector('.uploaded-files');
                    errorBag = cntr.querySelector('.form-error') ||
                        $tap($e('div', { className: 'form-error' }), function (div) { return cntr.append(div); });
                    btn = cntr.querySelector('.upload-select-file');
                    currFiles = uploaded.children.length;
                    maxFiles = +(cntr.dataset.max || 1);
                    if (maxFiles > 1 && currFiles + files.length > maxFiles) {
                        alert("\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3067\u304D\u308B\u306E\u306F ".concat(maxFiles, " \u30D5\u30A1\u30A4\u30EB\u307E\u3067\uFF08\u3042\u3068 ").concat(maxFiles - currFiles, " \u30D5\u30A1\u30A4\u30EB\uFF09\u3067\u3059\u3002"));
                        elem.value = '';
                        return [2 /*return*/];
                    }
                    if (maxFiles === 1 && currFiles > 0) {
                        Array.from(uploaded.children).forEach(function (elem) {
                            var li = elem;
                            if (li.dataset.url)
                                URL.revokeObjectURL(li.dataset.url);
                            li.remove();
                        });
                    }
                    uploads = [];
                    for (_i = 0, files_1 = files; _i < files_1.length; _i++) {
                        file = files_1[_i];
                        progress = $e('li', { className: 'upload-entry is-uploading', title: 'アップロード中...' }, $icon('fas fa-spinner fa-spin', { className: 'upload-entry-icon' }), $e('span', { className: 'upload-entry-title' }, "".concat(file.name, " (").concat($size(file.size), ")")));
                        uploaded.append(progress);
                        uploads.push([file, progress]);
                    }
                    alertUpload = function (ev) {
                        ev.preventDefault();
                        alert('アップロード中です。アップロード終了までお待ちください。');
                    };
                    elem.form.addEventListener('submit', alertUpload);
                    elem.addEventListener('click', alertUpload);
                    elem.value = '';
                    errorBag.hidden = true;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    q = new Queue();
                    _loop_1 = function (file, progress) {
                        q.enqueue(function () { return __awaiter(_this, void 0, void 0, function () {
                            var object_key;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, uploadFile(file)];
                                    case 1:
                                        object_key = _a.sent();
                                        progress.replaceWith(fileEntry(name, { object_key: object_key, file: file }, cntr.dataset.type, maxFiles > 1));
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                    };
                    for (_a = 0, uploads_1 = uploads; _a < uploads_1.length; _a++) {
                        _b = uploads_1[_a], file = _b[0], progress = _b[1];
                        _loop_1(file, progress);
                    }
                    return [4 /*yield*/, q.wait()];
                case 2:
                    _c.sent();
                    btn.disabled = maxFiles > 1 && uploaded.children.length >= maxFiles;
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _c.sent();
                    errorBag.replaceChildren("\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u306B\u5931\u6557\u3057\u307E\u3057\u305F: ".concat(err_1));
                    errorBag.hidden = false;
                    return [3 /*break*/, 5];
                case 4:
                    uploads.forEach(function (_a) {
                        var progress = _a[1];
                        return progress.remove();
                    });
                    elem.form.removeEventListener('submit', alertUpload);
                    elem.removeEventListener('click', alertUpload);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function uploadFile(file) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, url, key, res, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, fetchUploadUrl(file.name)];
                case 1:
                    _a = _d.sent(), url = _a.url, key = _a.key;
                    return [4 /*yield*/, fetch(url, {
                            method: 'PUT',
                            headers: { 'Content-Type': file.type },
                            mode: 'cors',
                            body: file,
                        })];
                case 2:
                    res = _d.sent();
                    if (!!res.ok) return [3 /*break*/, 4];
                    _c = (_b = console).error;
                    return [4 /*yield*/, res.text()];
                case 3:
                    _c.apply(_b, [_d.sent()]);
                    throw new Error("s3:PutObject failed: ".concat(res.status));
                case 4: return [2 /*return*/, key];
            }
        });
    });
}
function fetchUploadUrl(name) {
    return __awaiter(this, void 0, void 0, function () {
        var res, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!true) return [3 /*break*/, 5];
                    return [4 /*yield*/, fetch('/api/upload', {
                            method: 'POST',
                            headers: { 'X-XSRF-Token': xsrfToken() },
                            body: new URLSearchParams({ name: name }),
                        })];
                case 1:
                    res = _a.sent();
                    if (!res.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, res.json()];
                case 2:
                    json = _a.sent();
                    return [2 /*return*/, json];
                case 3:
                    if (res.status !== 429) {
                        throw new Error("Could not retrieve endpoint: ".concat(res.status));
                    }
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 500 + Math.random() * 2000); })];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 0];
                case 5: return [2 /*return*/];
            }
        });
    });
}
$$('.upload-files[data-initial]').forEach(function (cntr) {
    var name = cntr.dataset.name;
    var max = +(cntr.dataset.max || 1);
    var uploaded = cntr.querySelector('.uploaded-files');
    for (var _i = 0, _a = Object.values(JSON.parse(cntr.dataset.initial) || {}); _i < _a.length; _i++) {
        var file = _a[_i];
        uploaded.append(fileEntry(name, file, cntr.dataset.type, max > 1));
    }
    if (uploaded.children.length >= max) {
        cntr.querySelector('.upload-select-file').disabled = true;
    }
});
on('change', '.upload-files input[type=file]', function (ev) {
    handleUpload(ev.currentTarget).catch(console.error);
});
on('click', '.upload-select-file', function (ev) {
    ev.currentTarget.closest('.upload-files').querySelector('input[type=file]').click();
});
on('click', '.upload-entry-trash', function (ev) {
    var li = ev.currentTarget.closest('.upload-entry');
    var btn = li.closest('.upload-files').querySelector('.upload-select-file');
    if (li.dataset.url)
        URL.revokeObjectURL(li.dataset.url);
    li.remove();
    btn.disabled = false;
});
var dragging = undefined;
function posOf(ev) {
    return 'clientX' in ev ? ev : ev.touches[0];
}
function moveAt(_a, pos) {
    var clone = _a.clone, shiftX = _a.shiftX, shiftY = _a.shiftY;
    var root = document.documentElement;
    var rect = clone.getBoundingClientRect();
    var x = Math.min(Math.max(pos.pageX - shiftX, 0), root.clientWidth - rect.width);
    var y = Math.min(Math.max(pos.pageY - shiftY, root.scrollTop), root.scrollTop + root.clientHeight - rect.height);
    clone.style.left = "".concat(x, "px");
    clone.style.top = "".concat(y, "px");
}
function onStart(ev) {
    if (dragging || ev.target.closest('.upload-entry-trash'))
        return;
    var elem = ev.currentTarget;
    if (+(elem.closest('.upload-files').dataset.max || 1) == 1)
        return;
    var pos = posOf(ev);
    var clone = elem.cloneNode(true);
    var cntr = elem.closest('.uploaded-files');
    Object.assign(clone.style, {
        position: 'absolute',
        zIndex: '10000',
        width: "".concat(elem.clientWidth, "px"),
        height: "".concat(elem.clientHeight, "px"),
        touchAction: 'none',
    });
    document.body.append(clone);
    elem.classList.add('drag-ghost');
    cntr.style.touchAction = 'none';
    dragging = {
        cntr: cntr,
        ghost: elem,
        clone: clone,
        shiftX: pos.clientX - elem.getBoundingClientRect().left,
        shiftY: pos.clientY - elem.getBoundingClientRect().top,
    };
    moveAt(dragging, pos);
    ['mousemove', 'touchmove'].forEach(function (type) {
        document.body.addEventListener(type, onMove, { passive: false });
    });
    ['mouseup', 'touchend', 'touchcancel'].forEach(function (type) {
        document.body.addEventListener(type, onRelease);
    });
}
function onMove(ev) {
    var _a;
    if (!dragging || ev.buttons === 0 || ((_a = ev.touches) === null || _a === void 0 ? void 0 : _a.length) === 0)
        return onRelease();
    ev.preventDefault();
    var pos = posOf(ev);
    moveAt(dragging, pos);
    var cntr = dragging.cntr, ghost = dragging.ghost;
    var entry = Array.from(cntr.children).find(function (e) {
        var rect = e.getBoundingClientRect();
        return (rect.left <= pos.clientX && rect.right >= pos.clientX && rect.top <= pos.clientY && rect.bottom >= pos.clientY);
    });
    if (!entry || entry === ghost)
        return;
    var children = Array.from(cntr.children);
    var ghostIdx = children.findIndex(function (e) { return e === ghost; });
    var entryIdx = children.findIndex(function (e) { return e === entry; });
    if (ghostIdx > entryIdx) {
        cntr.insertBefore(ghost, entry);
    }
    else {
        cntr.insertBefore(ghost, entry.nextElementSibling);
    }
}
function onRelease() {
    if (dragging) {
        dragging.clone.remove();
        dragging.ghost.classList.remove('drag-ghost');
        dragging.cntr.style.touchAction = '';
        dragging = undefined;
    }
    ['mousemove', 'touchmove'].forEach(function (type) {
        document.body.removeEventListener(type, onMove);
    });
    ['mouseup', 'touchend', 'touchcancel'].forEach(function (type) {
        document.body.removeEventListener(type, onRelease);
    });
}
on(['mousedown', 'touchstart'], '.upload-entry:not(.is-uploading)', onStart);
on('dragstart', '.upload-entry', function (ev) { return ev.preventDefault(); });
